<template>
	<v-dialog v-model="dialog" width="700">
		<custom-dialog>
			<template v-slot:title>
				{{ t('shardMemberSetting') }}
				<button id="dialog_exit">
					<img src="@/assets/images/popup_close.png" id="btn_img" @click="dialog = false">
				</button>
			</template>
			<template v-slot:body>
				<v-row class="ma-0 pa-0" justify="center">
					<v-col class="ma-0 pa-0" cols="10">
						<v-col class="ma-0 pa-0 pb-3" cols="12" align="left">
							<v-col class="ma-0 pa-0 pb-5" cols="12">
								<v-row class="ma-0 pa-0" align="center">
									<v-col class="ma-0 pa-0 pr-2" cols="10">
										<v-autocomplete v-model="shareUserInputValue" :items="allShareUserList"
											:loading="searchLoading" :search-input.sync="search" append-icon=""
											color="white" dark hide-no-data hide-selected outlined dense hide-details
											item-text="displayName" :placeholder="t('shareInputPlaceholder')"
											:menu-props="{ contentClass: 'cg_share_menu' }"
											return-object style="width:100%;"></v-autocomplete>
									</v-col>
									<v-col class="ma-0 pa-0" cols="2">
										<v-btn width="100%" height="2rem" class="ma-0 pa-0"
											id="blue_btn" elevation="0" @click="addShareUser">
											{{ t('add2') }}
										</v-btn>
									</v-col>
								</v-row>
							</v-col>
							<v-col class="ma-0 pa-0" cols="12" id="user_list">
								<v-col class="ma-0 pa-0 pl-1 pr-1" cols="12"
									v-for="(item, index) in shareUserList" :key="index">
									<v-col class="ma-0 pa-2 pt-1 pb-1" cols="12" id="user_item">
										<v-row class="ma-0 pa-0" align="center" justify="space-between">
											<v-col class="ma-0 pa-0 pl-3" cols="auto">{{ item.name }}</v-col>
											<v-col class="ma-0 pa-0" cols="auto">{{ item.mailAddress }}</v-col>
											<v-btn width="auto" height="auto" class="ma-0 pa-0 mr-5"
												id="back_clean_btn" elevation="0" @click="deleteShareUser(index)">
												<v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0"
													src="@/assets/images/close.png"></v-img>
											</v-btn>
										</v-row>
									</v-col>
								</v-col>
							</v-col>
							<v-col class="ma-0 pa-0 mt-5" cols="12">
								<v-row class="ma-0 pa-0" align="center" justify="center">
									<v-btn width="8rem" height="auto" class="ma-0 pa-2"
										id="grey_btn" elevation="0" @click="cancelEdit">
										{{ t('back') }}
									</v-btn>
									<v-btn width="8rem" height="auto" class="ma-0 pa-2 ml-2" :loading="loading"
										id="blue_btn" elevation="0" @click="requestUpdate">
										{{ t('groupCreate') }}
									</v-btn>
								</v-row>
							</v-col>
						</v-col>
					</v-col>
				</v-row>
			</template>
		</custom-dialog>
	</v-dialog>
</template>

<script>
import mixin from '@/mixin';
import CustomDialog from '@/components/Modal.vue';
import { isEmpty, cloneDeep } from 'lodash';
export default {
	props: {
		dialogVisible: Boolean,
		// 대상 카메라그룹.
		group: { type: Object, default: null },
		// 현재 공유 사용자 목록 (부모가 /store/camera-group/{id}/share-user 로 조회해 전달)
		shareUsers: { type: Array, default: () => [] }
	},
	components: {
		CustomDialog
	},
	mixins: [mixin.common],
	data: () => ({
		dialog: false,
		allShareUserList: [],
		shareUserList: [],
		shareUserInputValue: {},
		searchLoading: false,
		loading: false,
		tempDeleteSharedUser: [],
		search: ''
	}),
	watch: {
		dialogVisible: function (item) {
			this.dialog = item;
			if (item) {
				this.tempDeleteSharedUser = [];
				this.shareUserList = cloneDeep(this.shareUsers || []);
			}
		},
		dialog: function (item) {
			this.$emit('visible', item);
		},
	},
	mounted() {
		this.getAllShareUserList();
	},
	methods: {
		async getAllShareUserList() {
			let params = {};
			await this.networkController.getShareUser(params).then(async (res) => {
				const userList = this.checkShareUserList(res.data.accounts);
				this.allShareUserList = userList.map(user => ({
					...user,
					displayName: `${user.name} (${user.mailAddress})`
				}));
			}).catch(error => { });
		},
		addShareUser() {
			const { name, mailAddress, umid, userName } = this.shareUserInputValue || {};
			if (isEmpty(umid)) {
				this.showToastMessage(this.tmb('failAddShareUser'));
				return;
			}
			if (isEmpty(mailAddress)) {
				this.showToastMessage('そのユーザーはメールアドレスを持たないユーザーです。');
				return;
			}
			const isAlreadyAdded = this.shareUserList.some(user => user.umid === umid);
			if (isAlreadyAdded) {
				this.showToastMessage(this.tmb('userAlreadyAdded'));
				return;
			}
			this.shareUserList.push({ mailAddress, umid, name, userName });
			this.shareUserInputValue = {};
		},
		deleteShareUser(index) {
			this.tempDeleteSharedUser.push(this.shareUserList[index]);
			this.shareUserList.splice(index, 1);
		},
		cancelEdit() {
			if (this.tempDeleteSharedUser.length != 0) {
				this.tempDeleteSharedUser.forEach(user => this.shareUserList.push(user));
			}
			this.dialog = false;
		},
		// 원본(shareUsers) 대비 추가/삭제를 계산하여 카메라그룹 공유사용자 등록/삭제 API 를 호출한다.
		async requestUpdate() {
			const groupId = this.group && this.group.id;
			if (!groupId) return;
			this.loading = true;
			const original = this.shareUsers || [];
			const originalUmids = new Set(original.map((u) => u.umid));
			const currentUmids = new Set(this.shareUserList.map((u) => u.umid));
			// 추가: 현재 목록 중 원본에 없던 사용자 → POST
			const toAdd = this.shareUserList
				.filter((u) => !originalUmids.has(u.umid))
				.map((u) => ({
					userName: u.userName,
					name: u.name,
					mailAddress: u.mailAddress,
					umid: u.umid,
					cameraGroupId: groupId,
				}));
			// 삭제: 원본에 있었으나 현재 목록에 없는 사용자의 id → DELETE
			const toDeleteIds = original
				.filter((u) => !currentUmids.has(u.umid))
				.map((u) => u.id)
				.filter(Boolean);
			try {
				if (toDeleteIds.length > 0) {
					await this.networkController.deleteCameraGroupShareUser(toDeleteIds, groupId);
				}
				if (toAdd.length > 0) {
					await this.networkController.addCameraGroupShareUser(toAdd, groupId);
				}
				this.showToastMessage(this.tmb('requestSuccess'));
				this.$emit('update'); // 부모가 목록/인원수 재조회
				this.loading = false;
				this.dialog = false;
			} catch (error) {
				this.showToastMessage(this.tmb('requestFail'));
				this.loading = false;
			}
		},
	}
}
</script>

<style lang="scss" scoped>
#user_list {
	border: 1px solid #4A4A4A;
	overflow: auto;
	min-height: 350px;
	max-height: 350px;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
#user_item {
	border-bottom: 1px solid #4A4A4A;
}
::v-deep {
	.v-input__slot {
		padding-right: 2px !important;
		min-height: 2rem !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}
	.v-autocomplete {
		background-color: #272727;
	}
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 30px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
</style>

<!-- autocomplete 추천(suggestion) 드롭다운은 body 로 teleport 되므로 비-scoped 로 배경/글자색 지정 -->
<style>
.cg_share_menu,
.cg_share_menu .v-list,
.cg_share_menu .v-select-list {
	background: #171921 !important;
}
.cg_share_menu {
	border: 1px solid #4A4A4A !important;
}
.cg_share_menu .v-list-item,
.cg_share_menu .v-list-item__content,
.cg_share_menu .v-list-item__title {
	color: white !important;
}
</style>
